import {ButtonProps} from '@/components/ui/button/Button'
import {StyledButton} from './style'
import {forwardRef} from 'react'

export const TableButton = forwardRef<HTMLButtonElement, ButtonProps & {isActive?: boolean}>(
    ({isActive, ...rest}, ref) => {
        return <StyledButton ref={ref} variant="secondary" size="sm" className={isActive ? 'active' : ''} {...rest} />
    }
)

TableButton.displayName = 'TableButton'
